import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { fluid } from '@/components/Landing/landingTokens';
import { MODEL_TOTAL, PROVIDER_TOTAL } from '@/constants/apiContent';
import ApiCodeSample from './ApiCodeSample';
import { ApiBody, ApiEyebrow, ApiLink, ApiSection, ApiSplit, useApiDesign } from './ApiEditorial';

function ApiHero({ topInset = 0 }) {
  const { c, width, compact, mobile } = useApiDesign();
  const size = fluid(width, 52, 80);
  return (
    <ApiSection label="Gab AI API" contentStyle={{ paddingTop: topInset + fluid(width, 120, 160), paddingBottom: fluid(width, 48, 72) }}>
      <ApiSplit style={{ alignItems: compact ? 'stretch' : 'center' }}>
        <View style={{ flex: compact ? undefined : 1, minWidth: 0 }}>
          <ApiEyebrow style={{ marginBottom: 24 }}>Gab AI for developers</ApiEyebrow>
          <Text tag="h1" weight="semibold" style={{ color: c.ink, fontSize: size, lineHeight: Math.round(size * 1.02), letterSpacing: -size * 0.055, whiteSpace: 'pre-line' }}>Every model.{'\n'}One API.</Text>
          <ApiBody style={{ fontSize: fluid(width, 18, 21), lineHeight: 31, marginTop: 26, maxWidth: 460 }}>Build with {MODEL_TOTAL} models from {PROVIDER_TOTAL} providers. Chat, images, video, and audio. All through one familiar API.</ApiBody>
          <View style={{ flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', gap: 20, marginTop: 30 }}>
            <ApiLink primary href="/signup">Get an API key</ApiLink>
            <ApiLink href="/docs/api">Read the docs</ApiLink>
          </View>
          <Text style={{ color: c.muted, fontSize: 12, lineHeight: 20, marginTop: 18 }}>Included with Plus and Plus Premium. Usage billed in credits.</Text>
        </View>
        <View style={{ flex: compact ? undefined : 1.1, minWidth: 0 }}><ApiCodeSample /></View>
      </ApiSplit>
      <View style={{ flexDirection: 'row', marginTop: fluid(width, 44, 64), paddingTop: 28, borderTopWidth: 1, borderTopColor: c.rule }}>
        {[
          { value: String(MODEL_TOTAL), label: 'Models to build with' },
          { value: String(PROVIDER_TOTAL), label: 'Leading providers' },
          { value: '1', label: 'Key for everything' },
        ].map((item, index) => (
          <View key={item.label} style={{ flex: 1, gap: 7, paddingLeft: index ? (mobile ? 16 : 32) : 0, borderLeftWidth: index ? 1 : 0, borderLeftColor: c.rule }}>
            <Text weight="semibold" style={{ color: c.ink, fontSize: mobile ? 30 : 36, lineHeight: 42, letterSpacing: -1.5 }}>{item.value}</Text>
            <Text style={{ color: c.secondary, fontSize: mobile ? 11 : 13, lineHeight: 19 }}>{item.label}</Text>
          </View>
        ))}
      </View>
    </ApiSection>
  );
}
export default React.memo(ApiHero);
